import React from 'react';
import { OrderTabs } from 'store/order/orderNavigation/orderNavigationSlice';
import { FeesContainer } from 'components/order/fees/FeesContainer';
import { LoanDetailsContainer } from 'components/order/fees/feesOverviewCards/LoanDetailsContainer';
import { ReissueDiscountAlertContainer } from 'components/order/discounts/ReissueDiscountAlertContainer';
import { PermissionNotification } from 'components/accessControl/PermissionNotification';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { BalancesContainer } from '../../components/order/fees/feesOverviewCards/BalancesContainer';
import { ExpectedContainer } from '../../components/order/fees/feesOverviewCards/ExpectedContainer';
import { FundingStatuses } from 'components/order/fees/FundingStatuses';
import { useParams } from 'react-router';
import { PermissionWrapper } from '../../components/accessControl/PermissionWrapper';
import { useSetOrderNavigationTab } from 'utilities/hooks/useSetOrderNavigationTab';

export const FeesPage: React.FC = () => {
  const { orderId } = useParams<{ orderId: string }>();
  useSetOrderNavigationTab({ tab: OrderTabs.Fees });

  return (
    <PermissionWrapper allowedPermissions={[ePermissions.CdItemsV3Read]}>
      <PermissionNotification allowedPermissions={[ePermissions.CdItemsV3Edit]} />
      <ReissueDiscountAlertContainer />
      <div className={'flex flex-row justify-around gap-4'}>
        <LoanDetailsContainer />
        <ExpectedContainer orderId={orderId} />
        <BalancesContainer orderId={orderId} />
      </div>
      <FundingStatuses orderId={orderId} />
      <FeesContainer />
    </PermissionWrapper>
  );
};
